export default "__VITE_PUBLIC_ASSET__49e3a78c__"